export default __webpack_public_path__ + "static/media/join.706ae3ea.png";